import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'
import Contactus from '../Components/Contactus/Contactus'
import AboutInfo from "../Components/Aboutus/AboutInfo";
import AboutusSection from "../Components/Aboutus/Aboutus";
import Header from "../Components/Common/Header";
import OurFeature from "../Components/Aboutus/OurFeature";
import { useSelector } from 'react-redux';

function Aboutus() {
    const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div>
<Navbar/>
  <Header
   title={currentLocal.general.about}
   />
      <AboutusSection />
      <AboutInfo />
      {/* <OurFeature/> */}
<Contactus/>
<Footer/>
    </div>
  )
}

export default Aboutus
